import React from 'react';
import sanitizeHtml from 'sanitize-html-react';
import Carousel from '../../../../../componentsV2/CustomizedAntDesign/Carousel';
import ProductsV2DetailsHeader from '../DetailsHeader';
import './styles.scss';

const ProductsV2Details = ({
  loading,
  product,
  isVendorSelected = false,
  showDetailsDrawer = false,
  setShowDetailsDrawer = () => {},
  showClientCollectionModal = false,
  setShowClientCollectionModal = () => {},
  showShareProductModal = false,
  setShowShareProductModal = () => {},
  showDeleteProductModal = false,
  setShowDeleteProductModal = () => {},
  fetchProduct = () => {},
  handleOnSuccessSave = () => {},
  isClientPage = false,
  getImageUrl = () => {},
  isVendorRolex = false,
  onOpenAddInquiry = () => {},
}) => {
  return (
    <div className="products-v2-details">
      {loading && !product ? <div>Loading...</div> : null}

      {!loading && !product ? <div>No Product Selected</div> : null}

      {product ? (
        <>
          <ProductsV2DetailsHeader
            loading={loading}
            product={product}
            showDetailsDrawer={showDetailsDrawer}
            setShowDetailsDrawer={setShowDetailsDrawer}
            showClientCollectionModal={showClientCollectionModal}
            setShowClientCollectionModal={setShowClientCollectionModal}
            showShareProductModal={showShareProductModal}
            setShowShareProductModal={setShowShareProductModal}
            showDeleteProductModal={showDeleteProductModal}
            setShowDeleteProductModal={setShowDeleteProductModal}
            fetchProduct={fetchProduct}
            handleOnSuccessSave={handleOnSuccessSave}
            isClientPage={isClientPage}
            isVendorRolex={isVendorRolex}
            onOpenAddInquiry={onOpenAddInquiry}
          />

          <div className="products-v2-details__details">
            <div className="products-v2-details__details-left">
              <span className="products-v2-details__details-price">{product.msrp || product.price}</span>
              {product.sku || product.mpn ? (
                <span className="products-v2-details__details-ref">{product.sku || product.mpn}</span>
              ) : null}
            </div>

            <div className="products-v2-details__details-right">
              {product.posRefNum ? (
                <span
                  className="products-v2-details__details-pos-ref-num"
                  style={{ marginRight: isClientPage ? 0 : '16px' }}
                >
                  POS: {product.posRefNum}
                </span>
              ) : null}

              {!isVendorSelected ? (
                <span className="products-v2-details__details-available">
                  <span
                    className={`products-v2-details__details-${
                      product.qty === null || product.qty > 0 ? 'in-stock' : 'out-of-stock'
                    }`}
                  >
                    •
                  </span>

                  {product.qty === null || product.qty > 0 ? 'In stock' : 'Out of Stock'}
                </span>
              ) : null}
            </div>
          </div>

          {product.description ? (
            <div
              className="products-v2-details__description"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(product.description) }}
            />
          ) : null}

          <Carousel images={product.images} isClientPage={isClientPage} getImageUrl={getImageUrl} />
        </>
      ) : null}
    </div>
  );
};

export default ProductsV2Details;
